<template>
  <div>
    <HeaderComp />
    <SectionSlider />
    <SectionNad1 />
    <SectionNad2 />
    <SectionChart />
    <SectionIntro />
    <SectionIntro2 />
    <SectionBenefit />
    <SectionDnaRepair1 />
    <SectionDnaRepair2 />
    <SectionTesti />
    <SectionAbout/>
    <!-- <SectionMap/> -->
    <!-- <LocModal/> -->
    <FooterComp />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderComp from '@/components/HeaderComp.vue'
import SectionSlider from '@/components/contents/SectionSlider.vue'
import SectionNad1 from '@/components/contents/SectionNad1.vue'
import SectionNad2 from '@/components/contents/SectionNad2.vue'
import SectionChart from '@/components/contents/SectionChart.vue'
import SectionIntro from '@/components/contents/SectionIntro.vue'
import SectionIntro2 from '@/components/contents/SectionIntro2.vue'
import SectionBenefit from '@/components/contents/SectionBenefit.vue'
import SectionDnaRepair1 from '@/components/contents/SectionDnaRepair1.vue'
import SectionDnaRepair2 from '@/components/contents/SectionDnaRepair2.vue'
import SectionTesti from '@/components/contents/SectionTesti.vue'
import SectionAbout from '@/components/contents/SectionAbout.vue'
// import SectionMap from '@/components/contents/SectionMap.vue'


/* import LocModal from '@/components/contents/LocModal.vue' */
import FooterComp from '@/components/FooterComp.vue'

import axios from 'axios'

export default {
  name: 'HomeView',
  components: {
    HeaderComp,
    SectionSlider,
    SectionNad1,
    SectionNad2,
    SectionChart,
    SectionIntro,
    SectionIntro2,
    SectionBenefit,
    SectionDnaRepair1,
    SectionDnaRepair2,
    SectionTesti,
    SectionAbout,
    // SectionMap,
    /* LocModal, */
    FooterComp
  },
  data() {
    return {
      show: 0,
      username: null,
      noTelp: '62811959901'

      // selectedProvince: '',
      // selectedCity: '',

      // provinces: [],
      // cities: []
      // }
    }
  },

  mounted() {
    // this.username = window.location.pathname.replace("/", "");
    this.username = this.$route.params.username
    // console.log(this.username)
    if (this.username) {
      axios
        .get(`https://api.bisnisonlinebgs.com/api/content/member/getMemberById/${this.username}`)
        .then(response => {
          this.noTelp = response.data.data[0].mobile_no
          // console.log(response.data.data[0].mobile_no)
        });
    } /* else {
        console.warn("No valid username in the URL. Loading default data or performing other actions.");
      } */

    /* if(this.username == ""){
      document.getElementById("myModal").style.display = "block";
    }else if(this.username !== ""){
      document.getElementById("myModal").style.display = "none";
      location.reload()
    }
  } */
    // created() {
    //   this.currPage = window.location.pathname;
    //   console.log(this.currPage)
    // }
  }
}
</script>
